export const alertPaths = {
  management: 'alerts-management',
};
